export default {
  state: {
    photo: null
  },
  mutations: {
    setPhoto (state, payload) {
      state.photo = payload
    }
  },
  actions: {
    async uploadPhoto ({commit, dispatch}, {photo}) {
      let formData = new FormData()
      formData.append('photo', photo)
      let post = {
        data: formData
      }

      let returnData = null
      post.url = '/admin/photo/upload?access_token=' + this.getters.accessToken
      post.json = false
      await dispatch('apiPost', post)
        .then((data) => {
          commit('setPhoto', data.photo)
          returnData = data
        })
        .catch((error) => {
          throw error
        })
      return returnData
    }
  },
  getters: {
    photo (state) {
      return state.photo
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/photo.js